import { Dispatch } from 'redux';

import { Settings } from '../models/settings';

export const SETTINGS_UPDATE = 'SETTINGS_UPDATE';

const settingsUpdate = (settings: Partial<Settings>) => {
    return {
        type: SETTINGS_UPDATE,
        settings,
    };
};

export const updateSettings = (settings: Partial<Settings>) => {
    return (dispatch: Dispatch) => {
        const localSettings = {
            sidebarCollapsed: settings.sidebarCollapsed,
            activitySidebarCollapsed: settings.activitySidebarCollapsed,
            pageSize: settings.pageSize,
            selectedDetailPanel: settings.selectedDetailPanel,
        };
        const jsonSettings = JSON.stringify(localSettings);
        localStorage.setItem('synergySettings', jsonSettings);

        dispatch(settingsUpdate(settings));
    };
};
